import { render, staticRenderFns } from "./MediaFeedWidget.vue?vue&type=template&id=6aac49af&scoped=true"
import script from "./MediaFeedWidget.vue?vue&type=script&lang=js"
export * from "./MediaFeedWidget.vue?vue&type=script&lang=js"
import style0 from "./MediaFeedWidget.vue?vue&type=style&index=0&id=6aac49af&prod&lang=scss"
import style1 from "./MediaFeedWidget.vue?vue&type=style&index=1&id=6aac49af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac49af",
  null
  
)

export default component.exports